import { api } from './api';
import type { NotificationsResponse } from './response_models/notifications/NotificationResponse';

export const notificationsApi = api.injectEndpoints({
  endpoints: builder => ({
    getNotifications: builder.query<NotificationsResponse, void>({
      query: () => ({
        url: 'notifications/',
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetNotificationsQuery } = notificationsApi;
